module.exports = __webpack_public_path__ + "img/dress.be5030ca.webp";